import React from 'react';
import css from './SessionStartStatus.module.css';

// Minimal shared inline treatment for the asynchronous session-start status
// (PR 2A). Deliberately NOT a modal or full-screen experience — a concise inline
// message rendered next to the initiating Start control. Renders nothing when
// idle, a brief loading line while the cert bank loads, or a concise error with
// a Retry action when a load fails. The initiating control disables itself while
// loading (handled by each parent); this component only surfaces status text.
//
// Status contract (no promises/refs/request-ids cross this boundary):
//   { status: 'idle' | 'loading' | 'error', error: string|null, canRetry: bool }
export default function SessionStartStatus({
  status,
  error,
  canRetry,
  onRetry,
  loadingText = 'Loading questions…',
}) {
  if (status === 'loading') {
    return (
      <div role="status" aria-live="polite" aria-busy="true"
           data-testid="session-start-loading" className={css.loading}>
        <span className={css.spinner} aria-hidden="true" />
        <span>{loadingText}</span>
      </div>
    );
  }
  if (status === 'error') {
    return (
      <div role="alert" data-testid="session-start-error" className={css.error}>
        <span className={css.errorText}>{error || 'Could not load questions. Please try again.'}</span>
        {canRetry && onRetry && (
          <button type="button" data-testid="session-start-retry"
                  className={css.retry} onClick={onRetry}>
            Retry
          </button>
        )}
      </div>
    );
  }
  return null;
}
